import { render, staticRenderFns } from "./CustomerFeedbacksWidget.vue?vue&type=template&id=1cede750&"
import script from "./CustomerFeedbacksWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedbacksWidget.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFeedbacksWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports